import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "@/i18n/I18nProvider";

export function Footer({ onOpenCookies }) {
  const { t, lang } = useTranslation();

  return (
    <footer className="bg-slate-950 text-slate-300 border-t border-slate-800" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-white text-slate-900 font-black tracking-tighter">E</span>
            <span className="font-black tracking-[0.18em] text-white text-[15px]">{t("brand.name")}</span>
          </div>
          <h4 className="text-white text-sm font-semibold mb-2">{t("footer.about_title")}</h4>
          <p className="text-sm leading-relaxed text-slate-400">{t("footer.about_text")}</p>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold mb-3">{t("footer.contact_title")}</h4>
          <address className="not-italic text-sm leading-relaxed text-slate-400 space-y-1">
            <div>{t("footer.address_line1")}</div>
            <div>{t("footer.address_line2")}</div>
            <div>{t("footer.address_line3")}</div>
            <div>
              <a
                href={`mailto:${t("footer.email")}`}
                className="text-slate-200 hover:text-amber-400"
                data-testid="footer-email"
              >
                {t("footer.email")}
              </a>
            </div>
            <div>
              <a
                href={`tel:${t("footer.phone").replace(/\s/g, "")}`}
                className="text-slate-200 hover:text-amber-400"
                data-testid="footer-phone"
              >
                {t("footer.phone")}
              </a>
            </div>
          </address>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold mb-3">{t("footer.legal_title")}</h4>
          <ul className="text-xs leading-relaxed text-slate-400 space-y-1.5" data-testid="footer-legal-info">
            <li>{t("footer.legal_form")}</li>
            <li>{t("footer.capital")}</li>
            <li>{t("footer.siret")}</li>
            <li>{t("footer.rcs")}</li>
            <li>{t("footer.vat")}</li>
            <li>{t("footer.ape")}</li>
            <li>{t("footer.director")}</li>
            <li>{t("footer.hosting")}</li>
            <li>{t("footer.cnil")}</li>
            <li>{t("footer.jurisdiction")}</li>
            <li>{t("footer.founded")}</li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold mb-3">{t("footer.links_title")}</h4>
          <ul className="text-sm space-y-2">
            <li>
              <Link
                to={`/${lang}/privacy`}
                className="text-slate-300 hover:text-amber-400"
                data-testid="footer-privacy-link"
              >
                {t("footer.privacy")}
              </Link>
            </li>
            <li>
              <Link
                to={`/${lang}/cookie-policy`}
                className="text-slate-300 hover:text-amber-400"
                data-testid="footer-cookie-link"
              >
                {t("footer.cookies")}
              </Link>
            </li>
            <li>
              <Link
                to={`/${lang}/terms`}
                className="text-slate-300 hover:text-amber-400"
                data-testid="footer-terms-link"
              >
                {t("footer.terms")}
              </Link>
            </li>
            <li>
              <button
                type="button"
                onClick={onOpenCookies}
                className="text-slate-300 hover:text-amber-400 text-left"
                data-testid="footer-manage-cookies"
              >
                {t("footer.manage_cookies")}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>{t("footer.copyright")}</span>
          <span>{t("footer.email")} · {t("footer.phone")}</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
